import { resolvePowSolution as e } from "./runPhoneOtpSend.mjs";
import { useMutation as t } from "@maat/store-hooks";
import { usersApi as n } from "@maat/api-main";
//#region src/phone/useLinkPhoneSendMutation.ts
var r = (r) => t({
	mutationFn: async (t) => {
		let i = await e(r);
		return n.phoneSend({
			...t,
			...i ? { pow_solution: i } : {}
		});
	},
	retry: !1
});
//#endregion
export { r as useLinkPhoneSendMutation };
